import { get, put, post } from 'services/api-client';

const userService = {
  getCurrent: () => get(`/user/current`),

  update: (data) => put(`/user/update`, data),

  disable: (id) => post(`/user/${id}/disable`),

  verifyEmailToken: (data) => post(`/user/verify/email-token`, data),

  verifyEmail: (email) => post(`/user/verify/email?email=${encodeURIComponent(email)}`),

  getByUsername: (data) => get(`/user/by-username?username=${encodeURIComponent(data)}`),

  resendInvitation: (id) => post(`/user/${id}/invitation/resend`)
}

export default userService;
